import { Fragment } from "react";
import Laoder from "../../../components/loading/Loader";
import style from "./Cities.module.css";
import getCity from "./functions/getCity";

function Cities({ cities = [], loading, set, setLoading }) {
  if (loading === true)
    return (
      <div className={style.box}>
        <Laoder />
      </div>
    );

  if (cities.length > 0)
    return (
      <div className={style.box}>
        {cities.map(item => (
          <article
            key={item.id}
            onClick={() => getCity(item.id, setLoading, set)}
          >
            {item.faName}
          </article>
        ))}
      </div>
    );

  return <Fragment></Fragment>;
}

export default Cities;
